import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { Breadcrumbs } from '../../../../components/UI/ComponentsUI';
import { translate, getUrlRepositoryApi, isNullOrEmpty } from '../../../../utils/util';

const InvoiceDetails = (props) => {
    const [urlImage, setUrlImage] = useState('');

    useEffect(() => {
        if (props.invoiceFile?.fileName) {
            setUrlImage(`${getUrlRepositoryApi(window)}/api/repository/file/download?FileName=expedition/notas/${props.invoiceFile.fileName}`);
        }
        // eslint-disable-next-line
    }, [props.invoiceFile]);

    const donwloadImage = () => {
        const tempLink = document.createElement('a');

        tempLink.href = urlImage;
        tempLink.download = props.invoiceFile.fileName;
        tempLink.target = "_blank";
        document.body.append(tempLink);
        tempLink.click();
        window.URL.revokeObjectURL(urlImage);
        tempLink.remove();
    }

    return (
        <div>
            <Breadcrumbs id="pickinginvoice" title={{ icon: "mdi mdi-clipboard-check-outline", label: translate('expedition:picking.insert-invoice') }} />
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className='container'>
                    <div className='card'>
                        <div className="card-content" style={{ padding: '5px', paddingBlockEnd: '1px' }}>
                            <div className="row" style={{ marginBottom: '0px' }}>
                                <div className="row" style={{ marginBottom: '0px' }}>
                                    <div className="input-field no-padding col s12">
                                        <b className="field f-1r">Chave NF - {props.invoiceFile.invoiceKey}</b>
                                    </div>
                                    <div className="input-field no-padding col s12">
                                        <b className="field f-1r">Número NF - {props.invoiceFile.invoiceNumber}</b>
                                    </div>
                                </div>
                                {
                                    !isNullOrEmpty(urlImage) &&
                                    <div className="input-field padding col s12" style={{ paddingTop: '10px', justifyContent: 'center' }}>
                                        <img onClick={donwloadImage} alt="NF" src={urlImage} style={{ display: 'flex', width: '80%', justifyContent: 'center' }} />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    );
};

const mapStateToProps = (state) => {
    return {
        invoiceFile: state.pickingReducer.invoiceFile,
    };
};

const mapDispatchToProps = () => {
    return {
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(InvoiceDetails)));